// `source_location` codes carried on a social-starter draft angle's metadata — the source of truth
// for tagging a draft as a Change Ambassador, HelloCitizen, or plain social-starter campaign.
// Cross-repo string contract: these must match what petition-service's StaffPetitionOnCreate consumer
// keys off of to map the published petition to a campaign team. Kept in one place so the codes can
// never drift apart across the admin create, social-starter landing, and Start-A-Petition publish flows.
export const AMBASSADOR_SOURCE_LOCATION = 'change-ambassadors';
export const HELLOCITIZEN_SOURCE_LOCATION = 'hellocitizen';
export const SOCIAL_STARTER_SOURCE_LOCATION = 'social';
